//import { Input, Button, Flex } from 'antd';
import * as React from 'react';
import { useState, useEffect } from 'react';
//import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { useSnapshotPageName } from '@/stores/pageName';
// import { fetchProductList } from '@/service/product';
// import homeLogo from '@/assets/image/homeLogo.png';
//import '../css/'

const Home = () => {
  const [html, setHtml] = useState('');
  const { pageName, prePageName, setPageName, setPrePageName, setIsSearch, setSearchRegion, setSearchType } = useSnapshotPageName();

  async function fetchHtml() {
    setHtml(await (await fetch('./homePage.html')).text());
  }

  useEffect(() => {
    fetchHtml();
    //setHtml(contentHtml)
  }, []);

  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = "./js/search.js";
    script1.async = false;

    // Optional: Set up any event listeners, e.g., to log when the script has loaded
    script1.onload = () => console.log('Script1 loaded successfully');
    
    const script2 = document.createElement('script');
    script2.src = "./js/particles.min.js";
    script2.async = false;

    // Optional: Set up any event listeners, e.g., to log when the script has loaded
    script2.onload = () => console.log('Script2 loaded successfully');

    const script3 = document.createElement('script');
    script3.src = "./js/app.js";
    script3.async = false;

    // Optional: Set up any event listeners, e.g., to log when the script has loaded
    script3.onload = () => console.log('Script3 loaded successfully');

    // Append the script to the document head (or body, if preferred)
    
    const script = document.createElement('script');
    script.src = "./js/scroll.js";
    script.async = false;

    // Optional: Set up any event listeners, e.g., to log when the script has loaded
    script.onload = () => console.log('Script4 loaded successfully');

    const script5 = document.createElement('script');
    script5.src = "./js/js/jquery-3.2.1.min.js";
    script5.async = false;

    script5.onload = () => console.log('Script5 loaded successfully');

    // Append the script to the document head (or body, if preferred)
    document.head.appendChild(script1);
    document.head.appendChild(script2);
    document.head.appendChild(script3);
    document.head.appendChild(script);
    document.head.appendChild(script5);
    gio('page.set', 'OW_pageName_pvar', '欢迎页');
    gio('page.set', 'OW_pageType_pvar', '-');
    setPrePageName(pageName);
    setPageName('欢迎页');
    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script);
      document.head.removeChild(script5);
    };
    }, [html]);

     return (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    );
};

export default Home;
